
import TranResourcesApi from './src/Tranresources'
import SendSmsApi from './src/SendSmsApi'
import UniformConfigApi from './src/UniformConfigApi'


let apis = {
   TranResourcesApi,
   SendSmsApi,
   UniformConfigApi
};

export default apis;
